<template>
  <div class="background">
    <div class="wrap">
      <div @click="printPdf" class="noPrint">{{$t('print')}}</div>

      <div v-for="(day,index) in day1">

        <div class="chart-container">

          <div v-if="index>0">
            <!--<div class="page-seperator"></div>
            <div class="page-starter"><br/><br/></div>-->
            <!-- -->
            <div class="page-break"></div>
          </div>

          <div class="Hcp-main-header">
            <div class="main-header-left">
              <img src="../../assets/LOGO.png">
            </div>
            <div class="main-header-right">
              <p>{{$t('dailyReport')}}</p>
              <p style="font-size: 9px;">{{$t('date')}}:{{day}}</p>
            </div>
          </div>
          <table class="status-table1" :class="{'zh1':!isEn,'de1':isDe||isIt||isFr}">
            <tr>
              <td class="td1 td2">{{$t('uername')}}</td><td colspan="4" class="td2">{{statics.username}}</td>
              <td class="td1 td2">{{$t('fullName')}}</td><td colspan="4" class="td3">{{statics.name}}</td>
            </tr>
            <tr>
              <td rowspan="3" class="td1 td2">{{$t('devices')}}</td>
              <td class="td2" :id="'reportPdmTitle'+index" v-if="devices[index][0].trim()=='EasyPatch'">APP</td>
              <td class="td2" :id="'reportPdmTitle'+index" v-else>{{$t('pdm')}}</td>
              <td colspan="8" class="td3">{{devices[index][0]}}</td>
            </tr>
            <tr><td class="td2">{{$t('tran')}}</td><td colspan="8" class="td3">{{devices[index][1]}}</td></tr>
            <tr><td class="td2">{{$t('pumpBase')}}</td><td colspan="8" class="td3">{{devices[index][2]}}</td></tr>
            <tr>
              <td class="td1 td4">{{$t('disType')}}</td><td colspan="4" class="td4">{{statics.medical_history}}</td>
              <td class="td td4">{{$t('HbA1c')}}</td><td colspan="4">{{hb1c[0]}}</td>
            </tr>
          </table>
          <div class="small-hr"></div>

          <div :id="'chart1_1'+index" class="graph"></div>
          <div :id="'chart1_2'+index" class="graph"></div>
          <div :id="'chart1_3'+index" class="graph"></div>

          <div class="spe-hr"></div>
          <div class="legend-group" :class="{'de2':isDe,'it2':isIt||isFr,'po2':isPo,'es2':isEs,'du2':isDu||isCz,'sw2':isSw}">
            <div class="legend" :class="{'it3':isIt}"><img src="../../assets/Hcp-icon/legend/Alert.png"><span>{{$t('alert')}}</span></div>
            <div class="legend" :class="{'it4':isIt}"><img src="../../assets/Hcp-icon/legend/target.png"><span>{{$t('target')}}</span></div>
            <div class="legend" :class="{'it5':isIt}"><img src="../../assets/Hcp-icon/legend/hypo.png" class="img-spe"> <span>{{$t('hypo')}}</span></div>
            <div class="legend legend-spe15"><img src="../../assets/Hcp-icon/legend/SG.png" class="img-spe"><span>{{$t('sensorGlucose')}}</span></div>
            <div class="legend legend-spe16"><img src="../../assets/Hcp-icon/legend/calib.png"><span :class="{'span1':!isEn}" class="span1">{{$t('calib')}}</span></div>
            <div class="legend legend-spe17"><img src="../../assets/Hcp-icon/legend/transmitter.png"><span>{{$t('newSen')}}</span></div>
            <div class="legend legend-spe5" :class="{'zh3':!isEn}"><img src="../../assets/Hcp-icon/legend/basal.png"><span>{{$t('basal')}}</span></div>
            <div class="legend legend-spe6" :class="{'zh4':!isEn,'du3':isDu}"><img src="../../assets/Hcp-icon/legend/temp basal.png"> <span>{{$t('tampBasal')}}</span></div>
            <div class="legend legend-spe12" :class="{'de5':isDe}"><img src="../../assets/Hcp-icon/legend/normal bolus.png"><span>{{$t('normalBolus')}}</span></div>
            <div class="legend legend-spe1" :class="{'zh5':!isEn,'de4':isDe}"><img src="../../assets/Hcp-icon/legend/extend bolus.png"><span>{{$t('extendBolus')}}</span></div>
            <div class="legend legend-spe7" :class="{'zh6':!isEn}"><img src="../../assets/Hcp-icon/legend/auto suspend.png"><span class="span1">{{$t('manualStop')}}</span></div>
            <div class="legend" style="margin-right: 10px;"><img src="../../assets/Hcp-icon/legend/warm up.png"><span  :class="{'span1':!isEn}">{{$t('warm')}}</span></div>
            <div class="legend legend-spe3"  :class="{'zh2':!isEn}"><img src="../../assets/Hcp-icon/legend/patch Deactivated.png"><span>{{$t('stop')}}</span></div>
            <div class="legend legend-spe4"  :class="{'zh18':!isEn}"><img src="../../assets/Hcp-icon/legend/Auto Suspend 2.png"><span class="span1">{{$t('autoStop')}}</span></div>
            <div class="legend legend-spe9" :class="{'zh7':!isEn}"><img src="../../assets/Hcp-icon/legend/new Patch.png"> <span>{{$t('newPatch')}}</span></div>
            <div class="legend legend-spe2" :class="{'zh8':!isEn}"><img src="../../assets/Hcp-icon/legend/exercise.png"><span>{{$t('exercise')}}</span></div>
            <div class="legend legend-spe10" :class="{'zh9':!isEn,'es3':isEs}"><img src="../../assets/Hcp-icon/legend/carbs.png"><span>{{$t('carbs')}}</span></div>
            <div class="legend"  style="margin-right: 0"><img src="../../assets/Hcp-icon/legend/calibrate_1.png"><span class="span1">{{$t('BG Reading')}}</span></div>
            <div class="legend legend-spe11"><img src="../../assets/Hcp-icon/legend/automode/早餐.png"><span>{{$t('Breakfast')}}</span></div>
            <div class="legend legend-spe11"><img src="../../assets/Hcp-icon/legend/automode/中餐.png"><span>{{$t('Lunch')}}</span></div>
            <div class="legend legend-spe11"><img src="../../assets/Hcp-icon/legend/automode/晚餐.png"><span>{{$t('Dinner')}}</span></div>
            <div class="legend legend-spe11"><img src="../../assets/Hcp-icon/legend/automode/零食.png"><span>{{$t('t1222_Snack')}}</span></div>
            <div class="legend legend-spe11"><img src="../../assets/Hcp-icon/legend/automode/运动[30059].png"><span>{{$t('Exercise')}}</span></div>
            <div class="legend legend-spe11"><img src="../../assets/Hcp-icon/legend/automode/icon_histogram.png"><span>{{$t('t1222_auto_basal')}}</span></div>
            <div class="legend legend-spe11"><img src="../../assets/Hcp-icon/legend/automode/auto_bolus.png"><span>{{$t('t1222_auto_bolus')}}</span></div>
          </div>
          <div class="statics">
            <p>{{$t('statics')}}</p>
            <table class="statics-table">
              <tr>
                <td colspan="3"  class="td1">{{$t('glucose')}}</td>
                <td rowspan="2" colspan="2" class="td1">{{$t('insulin')}}</td>
                <td rowspan="2" colspan="2" class="td2">{{$t('events')}}</td>
              </tr>
              <tr>
                <td class="td1"></td><td  class="td1">{{$t('BG1')}}</td><td  class="td1">{{$t('SG1')}}</td>
              </tr>
              <tr>
                <td  class="td1">{{$t('avgSD')}}</td><td  class="td1">{{glucose[index].bg_avg_dev}}</td><td  class="td1">{{glucose[index].sg_avg_dev}}</td>
                <td  class="td1">{{$t('totalDose')}}{{$t('ins_unit')}}</td><td  class="td1">{{insulin[index].total}}</td>
                <td  class="td1">{{$t('carbs')}}(g)</td><td class="td2">{{events[index].carb_total}}</td>
              </tr>
              <tr>
                <td  class="td1">{{$t('min')}}(mmol/L)</td><td class="td1">{{glucose[index].bg_min}}</td><td class="td1">{{glucose[index].sg_min}}</td>
                <td  class="td1">{{$t('bolus')}}{{$t('ins_unit')}}/%</td><td class="td1">{{insulin[index].bolus}}</td>
                <td  class="td1">{{$t('ofMeal')}}</td><td class="td2">{{events[index].meal_count}}</td>
              </tr>
              <tr>
                <td class="td1">{{$t('max')}}(mmol/L)</td><td class="td1">{{glucose[index].bg_max}}</td><td class="td1">{{glucose[index].sg_max}}</td>
                <td class="td1">{{$t('basal')}}{{$t('ins_unit')}}/%</td><td class="td1">{{insulin[index].basal}}</td>
                <td  class="td1">{{$t('avgSD1')}}</td><td class="td2">{{events[index].meal_avg_sd}}</td>
              </tr>
              <tr>
                <td class="td1">{{$t('target')}}(%)</td><td class="td1">{{glucose[index].bg_np}}</td><td class="td1">{{glucose[index].sg_np}}</td>
                <td class="td1">{{$t('foodBolus')}}{{$t('ins_unit')}}</td><td class="td1">{{insulin[index].carb_bolus}}</td>
                <td class="td1">{{$t('totalExerTime')}}</td><td class="td2">{{events[index].exercise_time}}</td>
              </tr>
              <tr>
                <td class="td1">{{$t('low1')}}(%)</td><td class="td1">{{glucose[index].bg_lp}}</td><td class="td1">{{glucose[index].sg_lp}}</td>
                <td class="td1">{{$t('calibBolus')}}{{$t('ins_unit')}}</td><td class="td1">{{insulin[index].corr_bolus}}</td>
                <td class="td1">{{$t('exerNum')}}</td><td class="td2">{{events[index].exercise_count}}</td>
              </tr>
              <tr>
                <td class="td1">{{$t('high1')}}(%)</td><td class="td1">{{glucose[index].bg_hp}}</td><td class="td1">{{glucose[index].sg_hp}}</td>
                <td class="td1"> {{$t('Food+coor')}} {{$t('ins_unit')}}</td><td class="td1">{{foodCoor[index]}}</td>
                <td class="td1">{{$t('avgInten')}}</td><td class="td2">{{events[index].exercise_avg_time}}</td>
              </tr>
              <tr>
                <td class="td1">{{$t('ofRead')}}</td><td class="td1">{{glucose[index].bg_rds_time}}</td><td class="td1">{{glucose[index].sg_data_num}}</td>
                <td class="td1">{{$t('normalBolus')}}{{$t('ins_unit')}}</td><td class="td1">{{insulin[index].normal_bolus}}</td>
                <td class="td1"></td><td class="td2"></td>
              </tr>
              <tr>
                <td class="td1">{{$t('ofHypo')}}</td><td class="td1">{{glucose[index].bg_hypo_rds_time}}</td><td class="td1">{{glucose[index].sg_hypo_num}}/{{glucose[index].sg_hypo_duration}}</td>
                <td class="td1">{{$t('extendBolus')}}{{$t('ins_unit')}}</td><td class="td1">{{insulin[index].extent_bolus}}</td>
                <td class="td1"></td><td class="td2"></td>
              </tr>
              <tr>
                <td class="td1">{{$t('ofAlert')}}</td><td class="td1">{{glucose[index].bg_alarm_cnt}}</td><td class="td1">{{glucose[index].sg_alarm_cnt}}</td>
                <td class="td1">{{$t('tampBasal')}}{{$t('ins_unit')}}</td><td class="td1">{{insulin[index].temp_basal}}</td>
                <td class="td1"></td><td class="td2"></td>
              </tr>
              <tr>
                <td class="td1"></td><td class="td1"></td><td class="td1"></td>
                <td class="td1">{{$t('durationStop')}}</td><td class="td1">{{insulin[index].suspend_time}}</td>
                <td class="td1"></td><td class="td2"></td>
              </tr>
              <tr>
                <td class="td3"></td><td class="td3"></td><td class="td3"></td>
                <td class="td3">{{$t('ofPumpAlert')}}</td><td class="td3">{{insulin[index].pump_alarm_cnt}}</td>
                <td class="td3"></td><td></td>
              </tr>
            </table>
          </div>


          <br/>
          <div class="statics">
            <!--        <p>{{$t('statics')}}</p>-->
            <table class="statics-table auto_mode" :class="{'de3':isDe}">
              <tr>
                <!--            <td colspan="3"  class="td1">{{$t('glucose')}}</td>-->
                <!--            <td rowspan="2" colspan="2" class="td1">{{$t('insulin')}}</td>-->
                <td rowspan="1" colspan="2" class="td2" style="height: 30px">{{$t('t1222_Auto_Mode')}}</td>
              </tr>
              <!--          <tr>-->
              <!--            <td class="td1"></td><td  class="td1">{{$t('BG1')}}</td><td  class="td1">{{$t('SG1')}}</td>-->
              <!--          </tr>-->
              <tr>
                <!--            <td  class="td1">{{$t('Avg')}}{{unit}}{{$t('±SD')}}</td><td  class="td1">{{glucose.bg_avg_dev}}</td><td  class="td1">{{glucose.sg_avg_dev}}</td>-->
                <!--            <td  class="td1"> {{$t('totalDose')}} {{$t('ins_unit')}}</td><td  class="td1">{{insulin.total}}</td>-->
                <td  class="td1"> {{$t('t1222_Time_in_Auto_Mode')}}</td>
                <td class="td2">{{autoModeStat[index].timeInAutoMode}}</td>
              </tr>

              <tr>
                <!--            <td  class="td1">{{$t('min')}}{{unit}}</td><td class="td1">{{glucose.bg_min}}</td><td class="td1">{{glucose.sg_min}}</td>-->
                <!--            <td  class="td1">{{$t('bolus')}} {{$t('ins_unit')}}/%</td><td class="td1">{{insulin.bolus}}</td>-->
                <td  class="td1"> {{$t('t1222_Avg_SD')}}</td>
                <td class="td2">{{autoModeStat[index].autoModeSGAvgSD}} {{glucose_unit}}</td>
              </tr>
              <tr>
                <!--            <td class="td1">{{$t('max')}}{{unit}}</td><td class="td1">{{glucose.bg_max}}</td><td class="td1">{{glucose.sg_max}}</td>-->
                <!--            <td class="td1">{{$t('basal')}} {{$t('ins_unit')}}/%</td><td class="td1">{{insulin.basal}}</td>-->
                <td  class="td1">{{$t('t1222_Target_Range')}}</td>
                <td class="td2">{{autoModeStat[index].autoModeSGInTargetRange}}</td>
              </tr>
              <tr>
                <!--            <td class="td1">{{$t('target')}} (%)</td><td class="td1">{{glucose.bg_np}}</td><td class="td1">{{glucose.sg_np}}</td>-->
                <!--            <td class="td1">{{$t('foodBolus')}} {{$t('ins_unit')}}</td><td class="td1">{{insulin.carb_bolus}}</td>-->
                <td class="td1">{{$t('t1222_Above_Range')}}</td>
                <td class="td2">{{autoModeStat[index].autoModeSGAboveRange}}</td>
              </tr>
              <tr>
                <!--            <td class="td1">{{$t('low1')}} (%)</td><td class="td1">{{glucose.bg_lp}}</td><td class="td1">{{glucose.sg_lp}}</td>-->
                <!--            <td class="td1">{{$t('calibBolus')}} {{$t('ins_unit')}}</td><td class="td1">{{insulin.corr_bolus}}</td>-->
                <td class="td1">{{$t('t1222_Below_Range')}}</td>
                <td class="td2">{{autoModeStat[index].autoModeSGBelowRange}}</td>
              </tr>
              <tr>
                <!--            <td class="td1">{{$t('high1')}} (%)</td><td class="td1">{{glucose.bg_hp}}</td><td class="td1">{{glucose.sg_hp}}</td>-->
                <!--            <td class="td1"> {{$t('Food+coor')}} {{$t('ins_unit')}}</td><td class="td1">{{foodCoor}}</td>-->
                <td class=" td3"> {{$t('t1222_Auto_Mode_Exits')}}</td>
                <td class=" ">{{autoModeStat[index].autoModeExits}}</td>
              </tr>


            </table>
          </div>


          <div v-if="index==day1.length-1" class="page-end"></div>

        </div>

      </div>


    </div>
  </div>
</template>

<script>
  import * as echarts from 'echarts'
  import auth from '../../auth/auth'
  import format from '@/lib/format'
  import B64 from '../../auth/base64'
  export default {
    data() {
      return {
        uid:0, et:0,st:0, time:'',   qst1:'',qet1:'',day1:[''],dayNum1:0, id11:[],id12:[],id13:[],foodCoor:[],isMg:'',ts:[],isIt:false,isPo:false,isEs:false,
        chart1_10:null,chart1_11:null,chart1_12:null,chart1_13:null,chart1_14:null,chart1_15:null,chart1_16:null,isCz:false,
        chart1_20:null,chart1_21:null,chart1_22:null,chart1_23:null,chart1_24:null,chart1_25:null,chart1_26:null,
        chart1_30:null,chart1_31:null,chart1_32:null,chart1_33:null,chart1_34:null,chart1_35:null,chart1_36:null,isDu:false,isFr:false,

        //DS统计数据
        statics:{},hb1c:['--'],
        devices:[['--','--','--'],['--','--','--'],['--','--','--'],['--','--','--'],['--','--','--'],['--','--','--'],['--','--','--'],
          ['--','--','--'],['--','--','--'],['--','--','--'],['--','--','--'],['--','--','--'],['--','--','--'],['--','--','--'], ],
        glucose:[[],[],[],[],[],[],[],[],[],[],[],[],[],[]],
        insulin:[[],[],[],[],[],[],[],[],[],[],[],[],[],[]],
        events:[[],[],[],[],[],[],[],[],[],[],[],[],[],[]],
        //DS图表
        newBasal:[],stopBasal:[],
        sgMax:20,basalMax:5,bolusMax:10,timeSection:[],transmtr:[],
        sensor_alarm:[], pump_alarm:[],carb:[],exercise:[[10,10,10,10,10]],calib:[],bg:[],isSw:false,
        extend_bolus:[[10,10,10,10,10]],basal_suspend:[],basal_suspend2:[],tempBasal:[],isDe:false,
        sleepTime1:[[10,10,10],[10,10,10]],
        sleepTime2:[[10,10,10],[10,10,10]],
        sleepTime3:[[10,10,10],[10,10,10]],
        chartColumn: null, chartColumn1: null, chartBar: null,isEn:false,
        autoModeBasal:[],
        autoModeCorrBolus:[],
        autoBreakfast:[],
        autoLunch:[],
        autoDinner:[],
        autoSnack:[],
        autoExercise:[],
        autoModeStat:[{},{},{},{},{},{},{},{},{},{},{},{},{},{}],
        pickerOptions:{
          disabledDate(time){
            return time.getTime()>Date.now();
          }
        },
        textStyle: {
          color: '#282828',
          fontWeight: 'normal',
          fontSize: '14',
          fontFamily: 'SFUIText-Regular'
        },
        titlePadding: [0, 0, 8, 33],
        grid: {x: '3.5%', y: '16%', width: '90%', height: '70%',},carbMax:100,
        sgRange: [['', '4.4', '8.9', '13.3', '17.8', '22.2'], ['', '0.2', '0.4', '0.6', '0.8', '1.0']
          , ['', '1', '2', '3', '4', '5'], ['0', '1', '2', '3', '4', '5'], ['', this.$t('Light'), '', this.$t('Medium'), '', this.$t('heavy')]],
        dateTime: ["00:00", " ", "", "3:00", "", "", "6:00", "", "", "9:00", "", "", "12:00", "", "", "15:00", "",
          "", "18:00", "", "", "21:00", "", "", "24:00",],
        yAxisLabel: {interval: 0, margin: 5, textStyle: {color: '#282828', baseline: 'middle'}, showMinLabel: false},
        glucose_unit:''
      }
    },
    computed: {
      DataS(){
        return this.$store.state.DataS;
      },
      DataSG(){
        return this.$store.state.DataSG;
      },
      DataBasal(){
        return this.$store.state.DataBasal;
      },
      DataBolus(){
        return this.$store.state.DataBolus;
      },
    },
    methods: {
      drawChart1_1(id) {
        let that =this;
        this[id]= echarts.init(document.getElementById(id));
        this[id].setOption({
          title: {
            text:(this.isMg)? this.$t('SG')+' (mg/dL)':this.$t('SG')+' (mmol/L)',
            textStyle: this.textStyle,
            padding: this.titlePadding,
          },
          xAxis: [{
            type: 'time',
            boundaryGap: false,
            min:new Date(this.timeSection[0]*1000),
            max:new Date(this.timeSection[1]*1000),
            axisLabel: {show:false,},
            axisLine: {lineStyle: {color: '#ccc'}},
            splitNumber: 24,
          }],
          yAxis: [{
            type: 'value',
            min:0,
            max:this.sgMax,
            axisLabel: this.yAxisLabel,
            axisLine: {lineStyle: {color: '#ccc'}},
            boundaryGap: false,
            axisTick: {length: 0},
          }],
          grid: this.grid,
          series: [
            {
              name:'SG',
              type: 'scatter',
              data: this.DataSG,
              markArea: {
                data: [
                  [{yAxis: (this.isMg)?this.DataS.blos_low*18:this.DataS.blos_low}, {yAxis:(this.isMg)?this.DataS.blos_high*18:this.DataS.blos_high}]
                ],
                itemStyle: {
                  normal: {
                    color: 'rgba(211,255,213,0.6)',
                  }
                }
              },
              markLine: {
                data: [{ yAxis:(this.isMg)?this.DataS.hypo*18:this.DataS.hypo}],
                symbol:['circle','circle'],
                silent:true,
                symbolSize: 1,
                lineStyle: {normal: {
                  color: 'rgba(255,0,0,0.5)',
                  type: 'solid',
                }},
                label:{normal:{show:false}},
              },
              itemStyle: {normal: {
                color:function (params) {
                  let color = '#2cd200';
                  if(params.value[1]<0.1&&params.value[2]==='H'){
                    color = '#666';
                  }
                  else{
                    if(that.isMg){
                      if(params.value[1]>that.DataS.blos_high*18){color = '#e6be00'}
                      if(params.value[1]<that.DataS.blos_low*18){color = '#ff5c5c'}
                    }else{
                      if(params.value[1]>that.DataS.blos_high){color = '#e6be00'}
                      if(params.value[1]<that.DataS.blos_low){color = '#ff5c5c'}
                    }
                  }
                  let type = params.value[2];
                  if((type==='NC'&&params.value[1]===0)||type==='DE'||type==='CE0'||type==='CE1'){
                    color = 'transparent';
                  }
                  return color;
                }
              }},
              symbolSize:2,
            },
            {
              type: 'scatter',
              data: this.sensor_alarm,
              symbol:'image://static/legend/Alert.png',
              symbolSize:13,
            },
            {
              type: 'scatter',
              data: this.calib,
              symbol:'image://static/legend/calib.png',
            },
            {
              type: 'scatter',
              data: this.bg,
              symbol:'image://static/legend/calibrate_1.png',
            },
            {
              type: 'scatter',
              data: this.transmtr,
              symbol:'rect',
              symbolSize:5,
              itemStyle: {normal: {color: '#00a107'}},
            },
            {
              type: 'custom',
              data:this.sleepTime1,
              z:-1,
              renderItem:function (params,api) {
                let y = api.value(2);
                let start = api.coord([api.value(0),y]);
                let size = api.size([api.value(1)-api.value(0),y]);
                let style = api.style();
                return {
                  type:'rect',
                  shape:{
                    x: start[0],
                    y: start[1],
                    width:size[0],
                    height:size[1],
                  },
                  style:style,
                }
              },
              itemStyle:{normal: {color: 'rgba(170,170,170,0.2)'}},
            },
          ],
        });
      },
      drawChart1_2(id) {
        this[id] = echarts.init(document.getElementById(id));
        this[id].setOption({
          title: [
            {
              text: this.$t('basal')+' '+this.$t('basal_unit'),
              textStyle: this.textStyle,
              padding: this.titlePadding,
            },
            {
              text: this.$t('bolus')+' '+this.$t('ins_unit'),
              textStyle: this.textStyle,
              right: '18',
            },
          ],
          xAxis: [{
            type: 'time',
            boundaryGap: false,
            min:new Date(this.timeSection[0]*1000),
            max:new Date(this.timeSection[1]*1000),
            interlval:0,
            axisLabel: {show:false,},
            axisLine: {lineStyle: {color: '#ccc'}},
            splitNumber: 24,
          }],
          yAxis: [
            {
              type:'value',
              boundaryGap: false,
              min:0,
              max:this.basalMax,
              axisTick: {length: 0},
              axisLabel: this.yAxisLabel,
              axisLine: {lineStyle: {color: '#ccc'}},
            }, {
              type:'value',
              boundaryGap: false,
              min:0,
              max:this.bolusMax,
              axisTick: {length: 0},
              axisLabel: this.yAxisLabel,
              axisLine: {lineStyle: {color: '#ccc'}},
              splitLine:{show:false,},
            }
          ],
          grid: this.grid,
          series: [
            {
              type: 'line',
              data:this.DataBasal,
              // step:'middle',
              itemStyle: {normal: {color: '#00ff40'}},
              symbolSize:2,
            },
            {
              type: 'line',
              data:this.basal_suspend,
              itemStyle: {normal: {color: '#ff0000'}},
              lineStyle:{normal:{type:'dashed'}},
              symbolSize:1,
            },
            {
              type: 'line',
              data:this.tempBasal,
              itemStyle: {normal: {color:  '#00ff40'}},
              lineStyle:{normal:{type:'dashed'}},
              symbolSize:1,
            },
            {
              type: 'line',
              data:this.basal_suspend2,
              itemStyle: {normal: {color: '#ff0000'}},
              symbolSize:1,
            },
            {
              type: 'scatter',
              data:this.newBasal,
              symbol:'image://static/legend/new Patch.png',
              symbolSize:10,
            },
            {
              type: 'scatter',
              data:this.stopBasal,
              symbol:'image://static/legend/patch Deactivated.png',
              symbolSize:8,
            },
            {
              type: 'scatter',
              data: this.pump_alarm,
              symbol:'image://static/legend/Alert.png',
              symbolSize:13,
            },
            {
              type: 'bar',
              data:this.DataBolus,
              yAxisIndex:1,
              itemStyle: {normal: {color: '#182f82'}},
              barWidth:'4',
            },
            {
              type: 'custom',
              data:this.extend_bolus,
              yAxisIndex:1,
              renderItem:function (params,api) {
                let y = api.value(2);
                let start = api.coord([api.value(0),y]);
                let size = api.size([api.value(1)-api.value(0),y]);
                let style = api.style();
                return {
                  type:'rect',
                  shape:{
                    x: start[0],
                    y: start[1],
                    width:size[0],
                    height:size[1],
                  },
                  style:style,
                }
              },
              itemStyle:{normal: {color: '#ffe3ef'},emphasis:{color: '#f00'}},
            },
            {
              type: 'custom',
              data:this.sleepTime2,
              z:-1,
              renderItem:function (params,api) {
                let y = api.value(2);
                let start = api.coord([api.value(0),y]);
                let size = api.size([api.value(1)-api.value(0),y]);
                let style = api.style();
                return {
                  type:'rect',
                  shape:{
                    x: start[0],
                    y: start[1],
                    width:size[0],
                    height:size[1],
                  },
                  style:style,
                }
              },
              itemStyle:{normal: {color: 'rgba(170,170,170,0.2)'},emphasis:{show:false}},
            },
            {
              type: 'custom',
              name:this.$t('t1222_autoModeBasal'),
              data:this.autoModeBasal,
              yAxisIndex:0,
              renderItem:function (params,api) {
                let y = api.value(2);
                let start = api.coord([api.value(0),y]);
                let size = api.size([api.value(1)-api.value(0),y]);
                let style = api.style();
                return {
                  type:'rect',
                  shape:{
                    x: start[0],
                    y: start[1],
                    width:size[0],
                    height:size[1],
                  },
                  style:style,
                }
              },
              tooltip:{backgroundColor:'#333',
                // formatter:function(params){
                //   let date = params.value[0];
                //   let time = format.formatterDate5(date);
                //   return time[0]+':'+time[1]+', '+params.value[4]+': '+params.value[2]+ins_unit2+'/'+params.value[3]+'min';
                // },
              },
              itemStyle:{normal: {color: '#00ff4c'},emphasis:{color: '#00ff5c'}},
            },
            {
              type: 'bar',
              name:this.$t('t1222_autoModeCorrBolus'),             // index 11
              data:this.autoModeCorrBolus,
              yAxisIndex:1,
              itemStyle: {normal: {color: '#182f82'}},
              tooltip:{backgroundColor:'#333',
                formatter:function(params){
                  // console.log('params:', params);
                  // let date = params.value[0];
                  // let time = format.formatterDate5(date);
                  // return time[0]+':'+time[1]+', '+params.value[2]+': '+params.value[1]+ins_unit2;
                },
              },
              barWidth:'4',
            },

          ]
        },false,true);
      },
      drawChart1_3(id) {
        let st_xaxis=this.timeSection[0]*1000;
        this[id] = echarts.init(document.getElementById(id));
        this[id].setOption({
          title: [
            {
              text: this.$t('carbs')+' (g)',
              textStyle: this.textStyle,
              left: this.titleLeft,
              padding: this.titlePadding,
            },
            {
              text: this.$t('exercise'),
              textStyle: this.textStyle,
              right: '22',
            }
          ],
          xAxis: [{
            type: 'time',
            boundaryGap: false,
            min:new Date(this.timeSection[0]*1000),
            max:new Date(this.timeSection[1]*1000),
            axisLabel:{
              showMaxLabel:true,
              margin: 10, textStyle: {color: '#282828', baseline: 'middle'} ,
              formatter:function (value,index) {
                // let H = new Date(value).getHours();
                index=(value-st_xaxis)/3600000;
                let H=index;
                if(index<24){
                  if(index%3===0){
                    H = H<10 ? ('0'+H+':00' ): H+':00';
                    return  H;
                  }else{
                    return ' ';
                  }
                }else{
                  return '24:00';
                }
              }
            },
            axisLine: {lineStyle: {color: '#ccc'}},
            splitNumber: 24,
          }],
          yAxis: [
            {
              type: 'value',
              axisLabel: this.yAxisLabel,
              axisLine:{lineStyle:{color:'#ccc'}},
              min:0,
              max:this.carbMax,
              boundaryGap: false,
              splitLine: {show: true,},
              axisTick: {length: 0},
            }, {
              data: this.sgRange[4],
              boundaryGap: false,
              axisTick: {length: 0},
              axisLabel: this.yAxisLabel,
              axisLine: {lineStyle: {color: '#ccc'}},
            }],
          grid: this.grid,
          series: [
            {
              type: 'custom',
              data:this.sleepTime3,
              z:-1,
              renderItem:function (params,api) {
                let y = api.value(2);
                let start = api.coord([api.value(0),y]);
                let size = api.size([api.value(1)-api.value(0),y]);
                let style = api.style();
                return {
                  type:'rect',
                  shape:{
                    x: start[0],
                    y: start[1],
                    width:size[0],
                    height:size[1],
                  },
                  style:style,
                }
              },
              itemStyle:{normal: {color: 'rgba(170,170,170,0.2)'}},
            },
            {
              type: 'custom',
              data:this.exercise,
              renderItem:function (params,api) {
                let y = api.value(2);
                let start = api.coord([api.value(0),y]);
                let size = api.size([api.value(1)-api.value(0),y]);
                let style = api.style();
                return {
                  type:'rect',
                  shape:{
                    x: start[0],
                    y: start[1],
                    width: size[0],
                    height: size[1],
                  },
                  style:style,
                }
              },
              itemStyle: {normal: {color: '#a1d9fd'},emphasis:{color: '#a1d9fd'}},
            },
            {
              type: 'scatter',
              data: this.carb,
              symbol:'rect',
              symbolSize:8,
              itemStyle: {normal: {color: '#00ff4c'},emphasis:{color: '#00ff4c'}},
            },
            {
              type: 'scatter',
              name:this.$t('t1222_autoSnack'),
              data:this.autoSnack,
              symbol:'image://static/legend/automode/零食.png',
              symbolSize:[29,18],
              symbolOffset:[0,-10],
              tooltip:{backgroundColor:'#333',
                formatter:function(params){
                  let date = params.value[0];
                  let time = format.formatterDate5(date);
                  //console.log('snack tip.');
                  return  time[0]+':'+time[1]+', Snack';
                },
              },
            },
            {
              type: 'scatter',
              name:this.$t('t1222_autoBreakfast'),
              data:this.autoBreakfast,
              symbol:'image://static/legend/automode/早餐.png',
              symbolSize:[29,18],
              symbolOffset:[0,-10],
              tooltip:{backgroundColor:'#333',
                formatter:function(params){
                  let date = params.value[0];
                  let time = format.formatterDate5(date);
                  return  time[0]+':'+time[1]+', Breakfast';
                },
              },
            },
            {
              type: 'scatter',
              name:this.$t('t1222_autoLunch'),
              data:this.autoLunch,
              symbol:'image://static/legend/automode/中餐.png',
              symbolSize:[29,18],
              symbolOffset:[0,-10],
              tooltip:{backgroundColor:'#333',
                formatter:function(params){
                  let date = params.value[0];
                  let time = format.formatterDate5(date);
                  return  time[0]+':'+time[1]+', Lunch';
                },
              },
            },
            {
              type: 'scatter',
              name:this.$t('t1222_autoDinner'),
              data:this.autoDinner,
              symbol:'image://static/legend/automode/晚餐.png',
              symbolSize:[29,18],
              symbolOffset:[0,-10],
              tooltip:{backgroundColor:'#333',
                formatter:function(params){
                  let date = params.value[0];
                  let time = format.formatterDate5(date);
                  return  time[0]+':'+time[1]+', Dinner';
                },
              },
            },
            {
              type: 'scatter',
              name:this.$t('t1222_autoExercise'),
              data:this.autoExercise,
              symbol:'image://static/legend/automode/运动[30059].png',
              symbolSize:[29,18],
              symbolOffset:[0,-10],
              tooltip:{backgroundColor:'#333',
                formatter:function(params){
                  let date = params.value[0];
                  let time = format.formatterDate5(date);
                  //console.log('Exercise tip:', time);
                  return  time[0]+':'+time[1]+', Exercise';
                },
              },
            },
          ]
        },false,true);
      },
      drawCharts(i) {
        this.drawChart1_1(this.id11[i]);
        this.drawChart1_2(this.id12[i]);
        this.drawChart1_3(this.id13[i]);
      },
      chartsDispose(){
        this.chart1_3.dispose();
      },
      getStatisticsQuick(report_data, i) {
        console.log('getStatisticsQuick:', report_data, i);
        let data =  report_data;
        data.medical_history = (data.medical_history )?this.$t(data.medical_history):"--";
        this.statics = data;
        this.devices[i] = (data.devices)?data.devices[0]:['--','--','--'];
        // if ('EasyPatch'==this.devices[i][0]) {
        //   document.getElementById('reportPdmTitle'+i).innerHTML='APP';
        // }
        this.hb1c = (data.hba1cList)?data.hba1cList:this.hb1c;
        this.glucose[i]  = (data.glucose_stat)?data.glucose_stat[0]:[];
        this.insulin[i] = (data.insulin_stat)?data.insulin_stat[0]:[];
        this.foodCoor[i] =(this.insulin[i].carb_corr_bolus)?(this.insulin[i].carb_corr_bolus).toFixed(2):0;
        this.events[i] =(data.event_stat)?data.event_stat[0]:[];
      },
      getStatics(param,i){
        this.$http.get('api/v2.1/report/'+this.uid+'/data/ds',{params:{param}}).then(function (res) {
          let err =res.body.error;
          if(err === 0){
            let data =  res.data.data;
            data.medical_history = (data.medical_history )?this.$t(data.medical_history):"--";
            this.statics = data;
            this.devices[i] = (data.devices)?data.devices[0]:['--','--','--'];
            this.hb1c = (data.hba1cList)?data.hba1cList:this.hb1c;
            this.glucose[i]  = (data.glucose_stat)?data.glucose_stat[0]:[];
            this.insulin[i] = (data.insulin_stat)?data.insulin_stat[0]:[];
            this.foodCoor[i] =(this.insulin[i].carb_corr_bolus)?(this.insulin[i].carb_corr_bolus).toFixed(2):0;
            this.events[i] =(data.event_stat)?data.event_stat[0]:[];
          }
        },function(err){
          let tip =  this.$t('tryAgain');
          this.$message.error(tip);
        })
      },
      printPdf(){
        auth.print_page();
      },
    },
    mounted: function () {
      self.document.title = this.$t('dailyReport');
      let lang = sessionStorage.getItem('language');
      this.isEn = (lang!=='zh'&&lang !=='hk')?true:false;
      this.isDe = (lang==='de')?true:false;
      this.isIt = (lang==='it')?true:false;
      this.isPo = (lang==='po')?true:false;
      this.isEs = (lang==='es')?true:false;
      this.isDu = (lang==='du')?true:false;
      this.isFr = (lang==='fr')?true:false;
      this.isSw = (lang==='sw')?true:false;
      this.isCz = (lang==='cz')?true:false;
      this.isMg = (localStorage.getItem('unit')==='mg')?true:false;
      this.sgMax = (this.isMg)? 400:25;
      this.glucose_unit = (this.isMg)?'mg/dL':'mmol/L';
      if(sessionStorage.getItem('userType')!=='P'){
        this.uid = parseInt(sessionStorage.getItem('patientId'));
      }else{
        this.uid = parseInt(sessionStorage.getItem('uid'));
      }
      this.qst1 = parseInt(sessionStorage.getItem('qst1'));
      this.qet1 = parseInt(sessionStorage.getItem('qet1'));
      this.dayNum1 = parseInt((this.qet1-this.qst1)/86400)+1;
      console.log(this.dayNum1)
      for(let i=0;i<this.dayNum1;i++){
         this.st =  this.qst1+i*86400;
         this.day1[i] =format.formatterDate2(this.st);
         this.id11[i] = 'chart1_1'+i;
         this.id12[i] = 'chart1_2'+i;
         this.id13[i] = 'chart1_3'+i;
         this.ts = [[this.st,this.st+86400]];
        let param = {
          ts:this.ts,
          tz:parseInt(sessionStorage.getItem('tz')),
          gu:(this.isMg)?'mg/dL':'mmol/L',
        };
        //console.log(param)
        param = B64.base64encode(JSON.stringify(param));
        //this.getStatics(param,i);
        auth.getDs(this,this.uid,param,i);
        let first = parseInt(sessionStorage.getItem('qFirst1'));
        if(first===1){
          auth.checkPrint(this,2,1);
        }
      }
    },
  }
</script>

<style scoped meadia="print">
  @page{
    *size:auto;
    size:portrait;
    margin: 0;
  }
  .background{
    width: 100%;
    padding-top: 0mm;
    *min-height: 297mm;
    background: #ccc;
  }
  .wrap{
    width: 210mm;
    margin:0 auto;
  }
  .background .noPrint{
    float: left;
    border-radius:100px;
    background: #fff;
    border: 1px solid #a3a3a3;
    outline: none;
    margin-top:4px;
    width:90px;
    height:26px;
    line-height: 28px;
    cursor: pointer;
    margin-left:-140px;
    font-size: 13px;
    text-align: center;
  }
  @media print {
    .background .noPrint{
      display: none;
    }
  }
  .chart-container {
    width:210mm;
    *height:297mm;
    font-family:SFUIText-Regular;
    font-size:12px;
    color:#282828;
    letter-spacing:-0.34px;
    background: #fff;
    margin:0 auto;
    padding-left: 20px;
    padding-right: 20px;
  }
  .Hcp-main-header{
    width:97%;
    height:40px;
    margin:0 auto;
    font-family:SFUIText-Regular;
    font-size:12px;
    color:#282828;
    padding-top: 10px;
  }
  .main-header-left{
    float: left;
  }
  .main-header-left img{
    height:45px;
    width: 100px;
  }
  .main-header-right{
    float: right;
    text-align: right;
    padding-top: 10px;
    margin-right: 15px;
  }
  .main-header-right p{
    font-size:12px;
    margin-bottom: 5px;
    letter-spacing:-0.29px;
    font-family:SFUIText-Regular;
    color:#282828;
  }

  .status-table1{
    width: 94%;
    margin:20px auto 16px;
    border:1px solid #747474;
    font-family:SFUIText-Regular;
    border-collapse: collapse;
    text-align:left;
    table-layout: fixed;
  }
  .status-table1 td{
    padding-left: 10px;
    height:15px;
  }
  .status-table1 .td1{
    width: 14%;
  }
  .zh1 .td1{
    width: 12%;
  }
  .de1 .td1{
    width: 11%;
  }
  .de1 td{
    padding-left: 3px;
  }
  .status-table1 .td2{
    border-bottom:1px solid rgba(116,116,116,0.34);
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .status-table1 .td3{
    border-bottom:1px solid rgba(116,116,116,0.34);
  }
  .status-table1 .td4{
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .small-hr{
    width:94%;
    margin:10px auto 16px;
    border-top:1px solid #3b3b3b;
  }
  .spe-hr{
    width:94%;
    border-top:1px solid #e6e8ea;
    margin:10px auto 10px;
  }
  .chart-container .graph{
    width:98%;
    margin-left: 2%;
    *height:160px;
    *height:40mm;
    height:32mm;
    margin-bottom: 5px;
  }

  .legend-group{
    width:97%;
    margin-left: 3%;
    font-family:SFUIText-Regular;
    font-size:10px;
    color:#282828;
    letter-spacing:-0.39px;
    text-align:left;
  }
  .legend{
    float:left;
    margin-bottom: 8px;
    margin-right:60px;
    height:20px;
    line-height: 20px;
  }
  .legend img{
    margin-right: 8px;
  }
  .legend-spe1{
    margin-right: 40px;
  }
  .legend-spe2{
    margin-bottom: 1px;
    margin-right: 90px;
  }
  .legend-spe3{
    margin-right: 30px;
  }
  .legend-spe4{
    margin-right: 35px;
  }
  .legend-spe5{
    margin-right:44px;
  }
  .legend-spe6{
    margin-right:40px;
  }
  .legend-spe7{
    margin-right: 30px;
  }
  .legend-spe8{
    margin-right: 70px;
  }
  .legend-spe9{
    margin-right: 58px;
  }
  .legend-spe10{
    margin-right: 88px;
  }
  .legend-spe11{
    margin-right: 40px;
  }
  .legend-spe12{
    margin-right:35px;
  }
  .legend-spe15{
    margin-right: 48px;
  }
  .legend-spe16{
    margin-right: 65px;
  }
  .legend-spe17{
    margin-right:0;
  }
  .zh2{
    margin-right: 50px;
  }
  .zh18{
    margin-right: 71px;
  }
  .zh3{
    margin-right: 40px;
  }
  .zh4{
    margin-right: 52px;
  }
  .zh5{
    margin-right: 32px;
  }
  .zh6{
    margin-right: 36px;
  }
  .zh7{
    margin-right: 56px;
  }
  .zh8{
    margin-right: 82px;
  }
  .zh9{
    margin-right: 65px;
  }
  .legend-group .span1{
    margin-bottom: 2px;
    display: block;
    float: right ;
  }
  .img-spe{
    margin-bottom: 4px;
  }
  .de2 .legend{
    margin-right: 30px;
  }
  .de2 .de4{
    margin-right: 20px;
  }
  .de2 .de5{
    margin-right: 15px;
  }
  .it2 .legend{
    margin-right: 32px;
  }
  .it2 .it3{
    margin-right: 46px;
  }
  .it2 .it4{
    margin-right: 50px;
  }
  .it2 .it5{
    margin-right: 60px;
  }
  .it2 .legend-spe15{
    margin-right: 48px;
  }
  .it2  .legend-spe16{
    margin-right: 65px;
  }
  .it2 .legend-spe17{
    margin-right:0;
  }
  .po2 .legend{
    margin-right: 22px;
  }
  .es2 .legend{
    margin-right: 32px;
  }
  .es2 .legend-spe15{
    margin-right: 48px;
  }
  .es2  .legend-spe16{
    margin-right: 65px;
  }
  .es2 .legend-spe17{
    margin-right:0;
  }
  .es2 .es3{
    margin-right: 72px;
  }
  .es2 .legend-spe6{
    margin-right: 15px;
  }
  .es2 .legend-spe7{
    margin-right: 15px;
  }

  .du2 .legend{
    margin-right: 32px;
  }
  .du2 .legend-spe15{
    margin-right: 28px;
  }
  .du2  .legend-spe16{
    margin-right: 25px;
  }
  .du2 .legend-spe17{
    margin-right:28px;
  }
  .du2 .du3{
    margin-right:45px;
  }

  .sw2 .legend-spe5{
    margin-right: 60px;
  }
  .sw2 .legend-spe1{
    margin-right: 30px;
  }
  .sw2 .legend-spe7{
    margin-right: 20px;
  }
  .sw2 .legend-spe3{
    margin-right: 35px;
  }
  .sw2 .legend-spe4{
    margin-right: 20px;
  }
  .sw2 .legend-spe9{
    margin-right: 40px;
  }
  .sw2 .legend-spe2{
    margin-right: 88px;
  }
  .sw2 .legend-spe10{
    margin-right: 55px;
  }
  .sw2 .legend-spe16{
    margin-right:58px;
  }

  .statics{
    clear: both;
  }
  .statics p{
    font-family:SFUIText-Regular;
    font-size:16px;
    color:#282828;
    letter-spacing:-0.27px;
    margin-left: 4%;
  }
  .statics-table{
    width: 94%;
    margin:10px auto 0;
    border:1px solid #747474;
    font-family:SFUIText-Regular;
    border-collapse: collapse;
    text-align:center;
    table-layout: fixed;
  }
  .statics-table.auto_mode {
    width: 50%;
    margin-left:3%;
  }
  .statics-table td{
    height:15px;
  }
  .statics-table .td1{
    border-bottom:1px solid rgba(116,116,116,0.34);
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .statics-table .td2{
    border-bottom:1px solid rgba(116,116,116,0.34);
  }
  .statics-table .td3{
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .page-seperator{
    margin-top:6mm;
  }
  .page-break {
    *page-break-after: always;
    page-break-before: always;
  }
  .page-end {
    clear:both;
    height:5mm;
  }
</style>



// WEBPACK FOOTER //
// quickPrint1.vue?6a5bfaea